export const queryKeys = {
  user: ['user'] as const,
  subscriptions: ['subscriptions'] as const,
  physio: (userId?: string) => ['physio', userId] as const,
  trainingPlan: (planId?: string) => ['training-plan', planId] as const,
  trainingPlanNoBackup: ['training-plan-nobackup'] as const,
  metadata: (planId?: string) => ['metadata', planId] as const,
  connectionProviders: ['connectionsProviders'] as const,
  progress: ['progress'] as const,
  athleteProfile: ['athlete-profile'] as const,
  advices: (section?: string) => ['advices', section] as const,
  adviceCategories: (section?: string) => ['advice-categories', section] as const,
  workoutAdvices: (text: string, section?: string) => ['workout-advices', text, section] as const,
  paymentFailedInvoice: ['paymentFailedInvoice'] as const,
  calendar: ['calendar'] as const,
  /** V2: range-parameterised, so invalidation must target the prefix, never `exact`. */
  enrollmentSessions: (from?: string, to?: string) => ['enrollment-sessions', from, to] as const,
  raceTypes: ['race-types'] as const,
  raceTypeFormats: (raceTypeId?: number) => ['race-type-formats', raceTypeId] as const,
  selectablePlans: (raceTypeId?: number, formatId?: string) => ['selectable-plans', raceTypeId, formatId] as const,
  settingsForm: (planId?: string) => ['settings-form', planId] as const,
  dateBounds: (planId?: string) => ['date-bounds', planId] as const,
  trainingSettings: ['training-settings'] as const,
  postRace: ['post-race'] as const,
  zoneTable: ['zone-table'] as const,
  referralSummary: ['referral-summary'] as const,
  calendarWorkout: (uuid: string) => ['calendar', 'workout', uuid] as const,
  sessionValidation: (workoutId: string) => ['session-validation', workoutId] as const,
  competitionResults: (filters?: Record<string, string | undefined>) =>
    ['competition-results', filters ?? {}] as const,
  addedCompetitions: (filters?: Record<string, string | undefined>) =>
    ['added-competitions', filters ?? {}] as const,
};
